import { Component, Input, OnInit } from '@angular/core';
import { CONSTS } from './download-note.constants';

@Component({
  selector: 'app-download-note',
  templateUrl: './download-note.component.html',
  styleUrls: ['./download-note.component.scss'],
  standalone: false,
})
export class DownloadNoteComponent implements OnInit {
  @Input() numRows!: string;

  displayedText = '';

  ngOnInit(): void {
    this.displayedText = CONSTS.text.replace('%n', this.numRows);
  }
}
